/**
 * Fired by the API instance on a 401 outside sign-in. The session provider (E4) listens to it and
 * sends the user back to the sign-in page. Same idea as `workspace:logout` in bodyprint-web.
 */
export const CUSTOM_EVENT_SESSION_LOGOUT = 'partner:logout';
